import { Pipe, PipeTransform } from '@angular/core';
import { parsePhoneNumberWithError } from 'libphonenumber-js';

@Pipe({
    name: 'phoneFormatLibPhone',
    standalone: true
})
export class PhoneFormatLibPhonePipe implements PipeTransform {
    transform(value: any, ...args: any[]) {
        if (!value) return '';
        try {
            const phoneNumber = parsePhoneNumberWithError(value)
            return phoneNumber.formatNational();
        } catch (error) {
            return value;
        }
    }
}
